import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '黄油作坊',
    url: 'https://huangyouzuofang.com',
    description: '黄油作坊是专注手工黄油制作的创意空间，提供从原料选择、发酵工艺到调味配方的全流程指南。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://huangyouzuofang.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '黄油作坊',
    url: 'https://huangyouzuofang.com',
    description: '专注手工黄油制作与美食创作灵感',
    email: 'hello@huangyouzuofang.com',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '上海',
      addressRegion: '静安区',
      streetAddress: '南京西路1688号',
    },
    sameAs: [
      'https://weibo.com/huangyouzuofang',
      'https://www.xiaohongshu.com/user/huangyouzuofang',
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <main>
        <Navbar />
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <NewsletterSection />
        <Footer />
      </main>
    </>
  );
}